// extracted by mini-css-extract-plugin
export default {"history-messages-item":"styles_history-messages-item__g+vnn","fetching":"styles_fetching__puJwW","show-description":"styles_show-description__aEcZ5"};